module.exports = __webpack_public_path__ + "static/img/icon h pptys 1.408757c2.svg";